var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.allowClick(_vm.link)) ? _c('router-link', {
    attrs: {
      "to": _vm.link.route
    }
  }, [_c('div', {
    staticClass: "icon-container d-flex justify-content-center align-items-center"
  }, [_c('b-icon', {
    staticClass: "icon",
    attrs: {
      "icon": _vm.link.icon,
      "title": _vm.link.display
    }
  }), _vm._v(" "), (_vm.isActive(_vm.link.route)) ? _c('div', {
    staticClass: "active-icon"
  }) : _vm._e()], 1)]) : _c('div', {
    staticClass: "icon-container d-flex justify-content-center align-items-center"
  }, [_c('b-icon', {
    staticClass: "icon",
    attrs: {
      "icon": _vm.link.icon,
      "title": _vm.link.display
    }
  }), _vm._v(" "), (_vm.isActive(_vm.link.route)) ? _c('div', {
    staticClass: "active-icon"
  }) : _vm._e()], 1)], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3de26cae","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/app/components/Layout/Sidebar/SidebarIcon.vue
// module id = sOKM
// module chunks = 2